var App = App || {};

App.SiteHeader = (function ($) {
    "use strict";

    var hovering = false;
    var megaMenuSpeed = 300;

    var alerts = $(".vc-site-alerts");
    var header = $(".vc-site-header");

    var selectorMenu = $(".vc-site-header-primary > nav > ul");
    var selectorItem = $(".vc-site-header-primary > nav > ul").children("li").children("a, button");

    var level2Menu = [];
    var level2MenuWhich = 0;
    var level2MenuItems = $(".vc-site-header-primary > nav > ul").children("li").find(".mega-menu").find("a, button");

    var offcanvasToggle = $("button[data-bs-toggle='offcanvas']");
    var offcanvasNavigation = $("#offcanvasNavigation");
    var offcanvasNavigationButton = offcanvasNavigation.find(".accordion-button");

    function init() {
        Search();

        $(".vc-site-header-primary").find("mega-menu").each(function () {
            $(this).find("a").attr("tabindex", -2);
        });

        /**********************************************************************************
         OFFCANVAS NAVIGATION
        /*********************************************************************************/
        OffcanvasNavigation();

        $(window).on("load resize orientationchange", OffcanvasNavigation);

        document
            .getElementById("offcanvasNavigation")
            .addEventListener("show.bs.offcanvas", function () {
                $("body").addClass("offcanvas-show");
            });

        document
            .getElementById("offcanvasNavigation")
            .addEventListener("hide.bs.offcanvas", function () {
                $("body").removeClass("offcanvas-show");
            });

        offcanvasNavigation.on("show.bs.offcanvas", function () {
            offcanvasToggle.html("<span class=\"far fa-times fa-2x fa-fw\"><span class=\"sr-only\">Close mobile navigation menu</span></span>");
        });

        offcanvasNavigation.on("hide.bs.offcanvas", function () {
            offcanvasToggle.html("<span class=\"far fa-bars fa-2x fa-fw\"><span class=\"sr-only\">Open mobile navigation menu</span></span>");
        });

        offcanvasNavigationButton.on("click", function (e) {
            var $this = $(this);

            if ($this.attr("aria-expanded") == "false") {
                if ($this.data("url") !== undefined) {
                    e.preventDefault();
                    e.stopPropagation();

                    window.location.href = $this.data("url");
                }
            }
        });

        /**********************************************************************************
         ENTIRE MENU END HOVER
        /*********************************************************************************/
        selectorMenu.hover(
            function () {

            },
            function () {
                hovering = false;
                selectorItem.blur();
                //MmOpen($(this).children("li").children("a"), megaMenuSpeed);
            }
        );

        /**********************************************************************************
         LEVEL ONE ITEM HOVER
        /*********************************************************************************/
        selectorItem.hover(
            function () {
                if (hovering !== true) {
                    MmOpen($(this), megaMenuSpeed);
                }
                else {
                    MmOpen($(this), 1);
                }
                hovering = true;
            },
            function () { }
        );

        /**********************************************************************************
         LEVEL ONE ITEM FOCUS
        /*********************************************************************************/
        selectorItem.focus(function () {
            MmOpen($(this), 1);
            hovering = true;
        });

        /**********************************************************************************
         LEVEL ONE ITEM BLUR
        /*********************************************************************************/
        selectorItem.blur(function () {
            if (hovering === false) {
                MmClose($(this), megaMenuSpeed);
            }
        });

        /**********************************************************************************
         LEVEL ONE ITEM ARROWS
        /*********************************************************************************/
        selectorItem.keydown(function (e) {
            // right arrow
            if (e.keyCode === 39) {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").focus();
            }
            // left arrow
            else if (e.keyCode === 37) {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                level2Menu = [];
                $(this).siblings(".mega-menu").find("a:visible, button:visible").each(function () { level2Menu.push(this); });
                level2MenuWhich = 0;
                $(level2Menu[level2MenuWhich]).focus();
            }
        });

        /**********************************************************************************
         LEVEL 2 ITEMS ARROWS
        /*********************************************************************************/
        level2MenuItems.keydown(function (e) {
            /* right arrow */
            if (e.keyCode === 39) {
                hovering = true;
                e.preventDefault();
                $(this).parents(".mega-menu").parent("li").next("li").children("a, button").focus();
            }
            /* left arrow */
            if (e.keyCode === 37) {
                hovering = true;
                e.preventDefault();
                $(this).parents(".mega-menu").parent("li").prev("li").children("a, button").focus();
            }
            // down arrow
            if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                if (level2MenuWhich < level2Menu.length - 1) { level2MenuWhich++; }
                else { level2MenuWhich = 0; }
                $(level2Menu[level2MenuWhich]).focus();
            }
            // up arrow
            if (e.keyCode === 38) {
                hovering = true;
                e.preventDefault();
                if (level2MenuWhich > 0) { level2MenuWhich--; }
                else { level2MenuWhich = level2Menu.length - 1; }
                $(level2Menu[level2MenuWhich]).focus();
            }
        });

        /**********************************************************************************
         ENTIRE EVERYTHING KEYPRESS - should we close that menu??
        /*********************************************************************************/
        selectorMenu.keydown(function (e) {
            if (e.keyCode === 9) {
                hovering = false;
                MmClose($(this).children("li").children("a, button"), 1);
            }
        });
    }

    function MmOpen(Menu, Speed) {
        Menu.attr("aria-expanded", "true").siblings(".mega-menu").stop().slideDown(Speed);
        MmClose(Menu.parents("li").siblings("li").children("a, button"), Speed);
    }

    function MmClose(Menu, Speed) {
        Menu.attr("aria-expanded", "false").siblings(".mega-menu").stop().slideUp(Speed);
    }

    function Search() {

        var Form = $(".vc-site-header-search form");
        var Input = Form.find("input[type='text']");
        var Submit = Form.find("button[type='submit']");

        Input.focus(function () {
            Form.addClass("active");
        });

        Input.blur(function () {
            if ($(this).val() === "") {
                Form.removeClass("active");
            }
        });

        Form.submit(function (e) {
            if (Input.val() === "") {
                e.preventDefault();
            }
        });
    }

    function OffcanvasNavigation() {
        var offset = $(header).outerHeight();

        if (alerts.length) {
            offset += $(alerts).outerHeight();
        }

        $(offcanvasNavigation).css("top", offset);
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteHeader.init();
});